<div class="row forms_area">
    <div class="progress">
        <div class="cicle_dotted form_valid" [ngClass]="{'form_valid': isFormValid()}" *ngIf="stepCompleted || isFormValid()"><span *ngIf="isFormValid()" class="material-symbols-outlined icon">
            check
        </span></div>
        <div class="line" *ngIf="decorativeLineVisible"></div>
    </div>
    <div class="card">
        <div class="card_header">
            <div class="row row_jc_space_btw row_ai_center">
                <p class="title fz_l fw_700">Клиент</p>
                <div class="btn_container">
                    <button *ngIf="isAnyFieldFilled()" class="btn btn_cancel" (click)="clearAll()">Очистить</button>
                </div>
            </div>
        </div>
        <div class="card_body">
            <ng-content></ng-content>
            <div *ngIf="order.customerId" class="filter_list grid">
                <label class="inp_group">
                    <div class="lbl">Имя</div>
                    <input type="text" name="customerfirstname" [(ngModel)]="order.firstname" class="inp"
                        placeholder="John">
                </label>
                <label class="inp_group">
                    <div class="lbl">Фамилия</div>
                    <input type="text" name="custcustomerlastname" [(ngModel)]="order.lastname" class="inp"
                        placeholder="Doe">
                </label>
                <label class="inp_group">
                    <div class="lbl">Телефон</div>
                        <app-input-tel name="customerPhone" [phoneValue]="order.phone" [phoneCode]="order.phone?.[0]" (phoneValueChange)="order.phone = $event"></app-input-tel>
                </label>
                <label class="inp_group">
                    <div class="lbl">Email</div>
                    <input type="text" name="customerEmail" [(ngModel)]="order.email" class="inp"
                        placeholder="xonisnik@gmail.com">
                </label>
            </div>
            <button [disabled]="!isFormValid()" (click)="openNextStep()"  class="btn dark_btn row fz_s fw_500 cursor_pointer">Дальше</button>
        </div>
    </div>
</div>